import { dateFormat, dateFormatIso, menuLinks, notifyMessages } from "./constants";
import { BookOutlined, BorderOuterOutlined, ExclamationCircleOutlined, FolderOpenOutlined, HomeOutlined, IdcardOutlined, ProfileOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { message } from "antd";
import dayjs from 'dayjs';
import JSZip from 'jszip';
import * as FileSaver from "file-saver";
import axios from 'axios';

export const generateMenuIcon = (menuName) => {
    let icon = null;
    switch (menuName) {
        case menuLinks.dashboard:
            icon = <HomeOutlined />;
            break;
        case menuLinks.raportiControllo:
            icon = <FolderOpenOutlined />;
            break;
        case menuLinks.fgas:
            icon = <FolderOpenOutlined />;
            break;
        case menuLinks.distinte:
            icon = <FolderOpenOutlined />;
            break;
        case menuLinks.anomalies:
            icon = <ExclamationCircleOutlined />;
            break;
        case menuLinks.divisions:
            icon = <BorderOuterOutlined />;
            break;
        case menuLinks.suppliers:
            icon = <IdcardOutlined />;
            break;
        case menuLinks.users:
            icon = <UserOutlined />;
            break;
        case menuLinks.attachments:
            icon = <BookOutlined />;
            break;
        default:
            icon = <RightOutlined />;
    }
    return icon;
}

export const handleDateConvertDayJs = (date) => {
    if (date) {
        let formatedDate = dayjs(date).format(dateFormat);
        return formatedDate
    }
    return null
}


export const handleDateConvertForApis = (date) => {
    if (date) {
        let formatedDate = dayjs(date).format(dateFormatIso);
        return formatedDate
    }
    return null
}

export const handleAnomalyDateConvertDayJs = (date) => {
    if (date) {
        let formatedDate = dayjs(date).format('D MMM YYYY');
        return formatedDate
    }
    return null
}

export const errorAlertDisplay = (response) => {
    if (response && response.errorDetail) {
        return message.error(response.errorDetail.errorMessage);
    }
    else {
        return message.error(notifyMessages.errorAccured);
    }
}

export const documentCategoryLayoutColor = (category) => {
    let categoryClassName = "";
    switch (category) {
        case 1:
            categoryClassName = "category1";
            break;
        case 2:
            categoryClassName = "category2";
            break;
        case 3:
            categoryClassName = "category3";
            break;
        default:
            categoryClassName = "category1";
    }

    return categoryClassName;
}

export const pageHeaderColor = (category) => {
    let pageHeaderClassName = "";
    switch (category) {
        case 1:
            pageHeaderClassName = "pageHeaderCat1";
            break;
        case 2:
            pageHeaderClassName = "pageHeaderCat2";
            break;
        case 3:
            pageHeaderClassName = "pageHeaderCat3";
            break;
        default:
            pageHeaderClassName = "pageHeaderCat1";
    }

    return pageHeaderClassName;
}

export const buttonColor = (category) => {
    let buttonClassName = "";
    switch (category) {
        case 1:
            buttonClassName = "buttonCat1";
            break;
        case 2:
            buttonClassName = "buttonCat2";
            break;
        case 3:
            buttonClassName = "buttonCat3";
            break;
        default:
            buttonClassName = "buttonCat1";
    }

    return buttonClassName;
}

export const downloadSelectedDocPdfFiles = async (pdfDocUrls, fileName) => {
    if (pdfDocUrls && pdfDocUrls.length > 0) {
        let zipFilename = fileName;
        const zip = new JSZip();
        for (const [index, item] of pdfDocUrls.entries()) {
            if (item && item.filePath != null) {
                try {
                    let filename = item.filePath.substring(item.filePath.lastIndexOf('/') + 1);
                    const response = await axios.get(item.filePath, { responseType: 'blob' });
                    zip.file(filename, response.data, { binary: true });
                } catch (error) {
                    console.error(`Error fetching:`, error);
                }
            }
        }
        zip.generateAsync({ type: 'blob' }).then(function (content) {
            FileSaver.saveAs(content, zipFilename);
        });
    }
    else {
        message.info(notifyMessages.noFileFound);
    }
}

export const generateRandomCode = () => {
    let min = 7;
    let max = 11

    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = Math.floor(Math.random() * (max - min + 1)) + min;

    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars[Math.floor(Math.random() * chars.length)];
    }

    return result;
}

export const generateNewFileName = (supplierName, originalFileName) => {
    const uniqueCode = generateRandomCode(8);

    const lastDotIndex = originalFileName.lastIndexOf('.');
    const namePart = originalFileName.slice(0, lastDotIndex);
    const extPart = originalFileName.slice(lastDotIndex);

    return `${supplierName}-${namePart}-${uniqueCode}${extPart}`;
}
